module.exports = __webpack_public_path__ + "static/media/19ESCAP2.5178a707.jpg";